// ══════════════════════════════════════════════════════════════════
// constants.js — La Conciergerie
// Constantes métier partagées entre tous les composants
// Extrait du Script 1 de index.html (migration Option A → Option B Vite)
// ══════════════════════════════════════════════════════════════════

// ══════════════ TYPES DE TÂCHES ══════════════
export const TT={
  checkin: {l:'Check-in',      c:'#4a9eff',bg:'#dbeeff',e:'🔑',cl:'ttc'},
  checkout:{l:'Check-out',     c:'#a855f7',bg:'#f3e8ff',e:'🚪',cl:'tto'},
  full:    {l:'Ménage complet',c:'#FF8617',bg:'#ffe9d6',e:'🧹',cl:'ttf'},
  quick:   {l:'Ménage rapide', c:'#86BD92',bg:'#e1f0e5',e:'⚡',cl:'ttq'},
  linge:   {l:'Linge',         c:'#C6B90C',bg:'#fff9d6',e:'🛏',cl:'ttl'},
  intervention:{l:'Intervention',c:'#0ea5e9',bg:'#e0f2fe',e:'🔧',cl:'tti'},
  verify:  {l:'Vérification',  c:'#FFAAAA',bg:'#ffe8e8',e:'✓', cl:'ttv'},
  // Correction : reprise sur un appartement suite à un problème (même rapport/checklist
  // qu'un ménage classique — voir isMenage dans PointageTerrain/GerantUI/StaffUI/etc.),
  // mais JAMAIS facturée au client (voir caTask dans TaskForm.jsx, garde dédiée comme 'verify').
  correction:{l:'Correction',  c:'#ef4444',bg:'#fee2e2',e:'🛠️',cl:'ttcr'},
  // Postes "sans appartement" : pas de bid, pas facturables, pas de rapport.
  // Servent à réserver un créneau sur le planning d'un salarié avant de connaître le détail
  // (ex: garde check-in tant qu'on ne sait pas encore quels appartements/horaires).
  // noBid:true pilote tout le comportement spécifique dans TaskForm / WeekPlan / AptPunch.
  gardeCheckin: {l:'Garde check-in',c:'#6366f1',bg:'#e0e7ff',e:'📋',cl:'ttgc',noBid:true},
  gardeBoutique:{l:'Boutique',      c:'#d97706',bg:'#fef3c7',e:'🏪',cl:'ttgb',noBid:true},
  rdvMedecine:  {l:'RDV médecine du travail', c:'#14b8a6',bg:'#e6fbf7',e:'🩺',cl:'ttrdvmed',noBid:true},
  buanderie:    {l:'Rangement buanderie',     c:'#78716c',bg:'#f5f4f2',e:'🧺',cl:'ttbua',   noBid:true},
};

// ══════════════ CHECKLIST MÉNAGE CLASSIQUE ══════════════
export const CL=[
  {id:'c1', lb:'Entrée / couloir',         cat:'Nettoyage'},
  {id:'c2', lb:'Salon aspiré',             cat:'Nettoyage'},
  {id:'c3', lb:'Cuisine nettoyée',         cat:'Cuisine'},
  {id:'c4', lb:'Lave-vaisselle vidé',      cat:'Cuisine',  pk:true,pl:'Photo LV ouvert'},
  {id:'c5', lb:'Réfrigérateur propre',     cat:'Cuisine',  pk:true,pl:'Photo réfrigérateur'},
  {id:'c6', lb:'Poubelles vidées',         cat:'Cuisine'},
  {id:'c7', lb:'Salle de bain nettoyée',   cat:'SdB'},
  {id:'c8', lb:'Douche / baignoire',       cat:'SdB'},
  {id:'c9', lb:'Miroirs',                  cat:'SdB'},
  {id:'c10',lb:'WC désinfecté',            cat:'SdB'},
  {id:'c11',lb:'Chambres aspirées',        cat:'Chambres'},
  {id:'c12',lb:'Linge propre en place',    cat:'Chambres', pk:true,pl:'Photo lit(s) fait(s)'},
  {id:'c13',lb:'Fenêtres fermées',         cat:'Départ'},
  {id:'c14',lb:'Lumières éteintes',        cat:'Départ'},
  {id:'c15',lb:'Porte vérouillée',         cat:'Départ',   pk:true,pl:'Photo porte fermée'},
];

// ══════════════ GROUPES PHOTOS ══════════════
export const GP=[{id:'g1',l:'Salon'},{id:'g2',l:'Cuisine'},{id:'g3',l:'Salle de bain'},{id:'g4',l:'Chambre(s)'}];

// ══════════════ TEMPLATES PIÈCES MÉNAGE (nouveau système configurable par bien) ══════════════
// Chaque type de pièce a sa checklist par défaut, qui sera copiée + éditable dans la fiche bien.
// Les pièces s'ajoutent à la liste mr[] du bien (avec mrOn=true pour activer le nouveau système).
// ph = nombre de photos par défaut demandées dans le rapport pour cette pièce (0 à 3).
// items = liste d'objets {lb, photo?:bool} — si photo=true, le salarié devra fournir une photo de ce point.

// ══════════════ TEMPLATES PIÈCES MÉNAGE (système configurable par bien) ══════════════
export const ROOM_TYPES=[
  {type:'entree',   e:'🚪',lb:'Entrée',           ph:0,items:[
    {lb:'Sol nettoyé'},{lb:'Tapis aspiré'},{lb:'Miroir essuyé'},{lb:'Surfaces dépoussiérées'}
  ]},
  {type:'salon',    e:'🛋️',lb:'Salon',            ph:2,items:[
    {lb:'Sol aspiré et nettoyé'},{lb:'Canapé & coussins remis en place'},{lb:'Surfaces dépoussiérées'},{lb:'Télécommandes en place'},{lb:'Poubelle vidée'}
  ]},
  {type:'cuisine',  e:'🍳',lb:'Cuisine',          ph:2,items:[
    {lb:'Lave-vaisselle vidé',photo:true},
    {lb:'Réfrigérateur propre',photo:true},
    {lb:'Plaques nettoyées'},
    {lb:'Four propre (intérieur + vitre)',photo:true},
    {lb:'Évier propre'},
    {lb:'Plan de travail nettoyé'},
    {lb:'Sol nettoyé'},
    {lb:'Poubelle vidée'}
  ],cfg:{lv:true,four:true,frigoAm:false}},
  {type:'chambre',  e:'🛏️',lb:'Chambre',          ph:1,items:[
    {lb:'Lit refait avec linge propre',photo:true},
    {lb:'Sol aspiré'},
    {lb:'Surfaces dépoussiérées'},
    {lb:'Poubelle vidée'}
  ],cfg:{nbLits:1}},
  {type:'sdb',      e:'🚿',lb:'Salle de bain',    ph:2,items:[
    {lb:'Douche / baignoire nettoyée',photo:true},
    {lb:'Lavabo nettoyé'},
    {lb:'Miroirs essuyés'},
    {lb:'WC désinfecté'},
    {lb:'Sol nettoyé'},
    {lb:'Serviettes propres en place'}
  ]},
  {type:'wc',       e:'🚽',lb:'WC',               ph:0,items:[
    {lb:'WC désinfecté'},{lb:'Lavabo nettoyé'},{lb:'Sol nettoyé'}
  ]},
  {type:'spa',      e:'💆',lb:'Spa',              ph:2,items:[
    {lb:'Spa vidé'},
    {lb:'Spa rincé'},
    {lb:'Spa rempli',photo:true},
    {lb:'pH vérifié',photo:true},
    {lb:'Jets nettoyés'},
    {lb:'Couverture remise en place'}
  ],suppl:'spa'},
  {type:'terrasse', e:'🌿',lb:'Terrasse / Balcon',ph:1,items:[
    {lb:'Sol balayé'},{lb:'Mobilier essuyé'},{lb:'Cendrier vidé'}
  ]},
  {type:'buanderie',e:'🧺',lb:'Buanderie',        ph:0,items:[
    {lb:'Lave-linge vidé'},{lb:'Filtre nettoyé'},{lb:'Sol nettoyé'}
  ]},
  {type:'depart',   e:'🔒',lb:'Départ (final)',   ph:0,items:[
    {lb:'Fenêtres fermées'},
    {lb:'Lumières éteintes'},
    {lb:'Climatisation OFF'},
    {lb:'Porte verrouillée',photo:true}
  ]},
  {type:'autre',    e:'📦',lb:'Autre',            ph:0,items:[]},
];

// ══════════════ BILL_TYPES — Bibliothèque d'items facturables ══════════════
export const BILL_TYPES=[
  {key:'spa',     em:'💆',  lb:'Supplément spa',             t:'b', tu:30},
  {key:'lit',     em:'🛏️',  lb:'Lit fait',                   t:'n', tu:5},
  {key:'animal',  em:'🐶',  lb:'Présence animal',            t:'b', tu:10},
  {key:'profond', em:'✨',  lb:'Ménage approfondi',          t:'b', tu:25},
  {key:'lvar',    em:'🧺',  lb:'Lave-linge supplémentaire',  t:'b', tu:8},
  {key:'vais',    em:'🍽️',  lb:'Vaisselle abondante',        t:'b', tu:10},
  {key:'repas',   em:'👕',  lb:'Pièces de linge à repasser', t:'n', tu:2},
  {key:'fumeur',  em:'🚬',  lb:'Logement fumeur',            t:'b', tu:20},
];

// ══════════════ DONNÉES INITIALES VIDES ══════════════
// (les vraies données sont chargées depuis Supabase par useSt)
export const DS=[];
export const DG=[
  {id:'g1',name:'Claire',role:'Direction',phone:'',email:'claire@laconciergerie.fr'},
  {id:'g2',name:'Franck',role:'Direction',phone:'',email:'franck@laconciergerie.fr'},
];
export const DP=[];
export const DC=[];
export const DB=[];
export const DST=[];
export const DPJ=[];
export const DL=[];
export const DU=[];
export const DR=[];
export const DM=[];
export const DTC=[];
export const DAL=[];
export const DREP=[];
const DCTRL=[];

// ══════════════ MODULE CONTRÔLE APPARTEMENTS ══════════════
export const CTRL_PIECES=[
  {id:'cuisine',  label:'Cuisine',      icon:'🍳'},
  {id:'salon',    label:'Salon',        icon:'🛋'},
  {id:'chambres', label:'Chambres',     icon:'🛏'},
  {id:'sdb',      label:'Salle de bain',icon:'🚿'},
  {id:'wc',       label:'WC',           icon:'🚽'},
];
export const CTRL_CHECKS=[
  {id:'lumieres', label:'Lumières éteintes'},
  {id:'electro',  label:'Appareils électriques branchés selon consignes'},
  {id:'chauffage',label:'Chauffages positionnés selon consignes'},
  {id:'fenetres', label:'Fenêtres fermées'},
  {id:'portes',   label:'Portes verrouillées'},
];

// ══════════════ MESSAGERIE — PIÈCES JOINTES ══════════════
// Bucket public "rapports" (voir uploadMsgAttachment dans supabase.js). Limites côté client,
// avant upload — protège les salariés sur connexion terrain faible d'un envoi qui traînerait
// ou échouerait silencieusement.
export const MSG_ATT_MAX_SIZE=15*1024*1024; // 15 Mo par pièce jointe
export const MSG_ATT_MAX_COUNT=5; // par message


// URL et clé anon lues depuis les variables d'environnement Vercel (import.meta.env.VITE_*).
// Fallback OBLIGATOIRE sur les valeurs de PROD : si les variables ne sont pas définies
// (build local, variable Vercel absente/vide), on retombe sur la prod → comportement identique
// à avant l'introduction des variables. C'est le garde-fou anti-casse du découpage staging/prod.
//   - Production Vercel → VITE_SUPA_* = projet prod ednquycjitdruojqmgjz (= ces fallbacks)
//   - Preview Vercel    → VITE_SUPA_* = projet staging rhyripcoxytcudacwkuj (base de test séparée)
// La clé anon est publique par conception (embarquée dans le bundle client).
export const SUPA_URL=import.meta.env.VITE_SUPA_URL||'https://ednquycjitdruojqmgjz.supabase.co';
export const SUPA_KEY=import.meta.env.VITE_SUPA_KEY||'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVkbnF1eWNqaXRkcnVvanFtZ2p6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1MTQwNzYsImV4cCI6MjA5NDA5MDA3Nn0.upVAXZFZseJ8qB5HVrWxMXSS55FAsLDGXc_77GklREw';

// ══════════════ VAPID (clé publique pour Web Push) ══════════════
// La clé publique VAPID n'est PAS un secret : par conception destinée à être exposée côté client.
// La clé privée est dans Google Doc "Credentials La Conciergerie".
export const VAPID_PUBLIC_KEY='BDPnpHbHSYqqy-6BDbG-ezRrRINiHOyU2Rru9V9PbbCWDJ1BLy6D7sx3-QZFxBFsquTkgYptgwveLkpeNLaSQls';

// URL officielle de l'app cliente (pour les emails reset password)
export const CLIENT_APP_URL='https://app.conciergerie-alsace.com';

// ══════════════ EVIIVO ══════════════
// Heures par défaut des tâches générées (modifiables à la main dans l'app)
export const EVIIVO_HEURES={checkin:{sh:16,sm:0},checkout:{sh:10,sm:0},full:{sh:10,sm:0}};

// ══════════════ CONSTANTES POINTAGE ══════════════
// Partagées entre Pointage (Script 2) et pauseStatus (utils)
export const HSTART=7,HEND=21,HTOT=(HEND-HSTART)*60;
export const PAUSE_REMINDER_MS=5.5*60*60*1000;  // 5h30 en ms
export const PAUSE_REQUIRED_MS=6*60*60*1000;    // 6h en ms (seuil légal)
export const PAUSE_MIN_DURATION_MS=30*60*1000;  // 30 min minimum (HCR)

// ══════════════ REGISTRE UNIQUE DU PERSONNEL ══════════════
// Art. L1221-13 et D1221-23 s. du Code du travail. Le registre se tient PAR
// ÉTABLISSEMENT, pas par société — d'où le siège social et non l'adresse
// commerciale (les deux sont déclarées, chacune a sa fonction).
// ⚠️ DETTE CONNUE : l'identité de la société est déjà écrite en dur dans
// `SecProp.jsx` (constante `SELLER`, utilisée par les Factur-X). Deux sources
// pour la même information — à unifier ici le jour où on y touche. Ne PAS
// modifier SELLER sans revérifier les factures déjà émises.
export const ETABLISSEMENT={
  nom:'LA CONCIERGERIE',
  siret:'94332595100011',
  adresse:'56 rue des Marchands',
  zip:'68000',
  ville:'Colmar',
};

// Pays dont les ressortissants n'ont PAS besoin d'un titre les autorisant à
// travailler en France : UE + EEE (Islande, Liechtenstein, Norvège) + Suisse.
// Sert uniquement à décider de l'AFFICHAGE du bloc « titre de travail » ; ce
// n'est pas un contrôle de conformité et ça ne bloque aucune saisie.
export const PAYS_SANS_TITRE=[
  'Allemagne','Autriche','Belgique','Bulgarie','Chypre','Croatie','Danemark',
  'Espagne','Estonie','Finlande','France','Grèce','Hongrie','Irlande','Islande',
  'Italie','Lettonie','Liechtenstein','Lituanie','Luxembourg','Malte','Norvège',
  'Pays-Bas','Pologne','Portugal','République tchèque','Roumanie','Slovaquie',
  'Slovénie','Suède','Suisse',
];

// Suggestions de saisie (datalist) — volontairement NON limitatives : le champ
// reste libre, toute nationalité doit pouvoir être saisie.
export const NATIONALITES_SUGGEST=[
  ...PAYS_SANS_TITRE,
  'Algérie','Brésil','Cameroun','Canada','Chine','Colombie','Congo','Côte d\'Ivoire',
  'États-Unis','Géorgie','Inde','Kosovo','Madagascar','Maroc','Maurice','Moldavie',
  'Népal','Philippines','Russie','Sénégal','Serbie','Sri Lanka','Tunisie','Turquie',
  'Ukraine','Viêt Nam',
].sort((a,b)=>a.localeCompare(b,'fr'));

// Titres autorisant un ressortissant étranger à travailler (mention obligatoire
// au registre : type ET numéro d'ordre — art. D1221-23).
export const TITRE_TYPES=[
  'Carte de séjour temporaire',
  'Carte de séjour pluriannuelle',
  'Carte de résident',
  'Titre de séjour « salarié »',
  'Titre de séjour « travailleur temporaire »',
  'Autorisation provisoire de travail',
  'Visa long séjour valant titre de séjour',
  'Récépissé de demande autorisant le travail',
  'Autre',
];

// ══════════════ CONSENTEMENT / ACCUSÉ RGPD SALARIÉS ══════════════
// SPEC_rgpd_consentement_v1.md (17/08/2026). Document versionné : toute évolution du
// texte se fait en créant une NOUVELLE entrée de version, jamais en réécrivant celle-ci
// — un accord déjà donné par un salarié sur `RGPD_DOC_V1.version` ne doit jamais être
// invalidé ni modifié rétroactivement par un changement de texte.
export const RGPD_DOC_V1={
  version:'v1',
  dateActivation:'2026-08-17',
  texte_fr:`Information sur le traitement de vos données personnelles et le suivi de votre activité

Dans le cadre de votre activité au sein de La Conciergerie, l'application utilisée pour la gestion de votre travail (pointage, rapports de ménage et de contrôle, planning, congés, messagerie) collecte et traite certaines données vous concernant :

• Données de pointage (heure et lieu au moment où vous pointez le début/fin d'une tâche), utilisées pour vérifier votre présence sur site et calculer votre temps de travail. Cette localisation n'est captée qu'au moment du pointage. Vous n'êtes pas suivi(e) en dehors de ces instants ni en dehors de vos horaires de mission.
• Photos des logements prises dans le cadre des rapports de ménage et de contrôle qualité, destinées à documenter l'état des biens (pas votre personne).
• Rapports de ménage et de contrôle (durée, points validés, observations), transmis aux propriétaires dans un objectif de transparence sur la qualité du service, et utilisés en interne pour le suivi de la qualité des prestations.

Finalités du traitement : ces données sont utilisées pour la gestion de la paie et du temps de travail, la transparence envers les propriétaires, le suivi et l'amélioration continue de la qualité de service et, le cas échéant, pour le suivi de l'exécution de vos missions (pouvant être utilisé dans le cadre d'un échange, d'un rappel des consignes ou d'une procédure disciplinaire si des manquements répétés aux consignes ou à la qualité attendue sont constatés).
Durées de conservation : la localisation précise associée à chaque pointage est conservée 6 mois, puis supprimée. Les heures de travail qui en sont dérivées (utilisées pour la paie) sont conservées 5 ans, conformément aux obligations légales. Les photos et rapports de ménage/contrôle sont conservés 24 mois. La localisation précise est accessible uniquement aux personnes habilitées de l'équipe de direction ; les heures de travail sont également transmises au cabinet comptable pour l'établissement de la paie ; les photos et rapports sont accessibles à la direction ainsi qu'au propriétaire du logement concerné, dans le cadre du suivi de la qualité du service.
Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et d'opposition sur vos données. Pour toute demande, contactez Franck Ferdoelle.`,
  checkbox_fr:`J'ai pris connaissance de cette information et du fait que les données de suivi d'activité (pointage, rapports) peuvent être utilisées dans le cadre du suivi de mon activité professionnelle.`,
  texte_es:`Información sobre el tratamiento de sus datos personales y el seguimiento de su actividad

En el marco de su actividad en La Conciergerie, la aplicación utilizada para gestionar su trabajo (fichaje, informes de limpieza y control, planning, vacaciones, mensajería) recopila y trata determinados datos que le conciernen:

• Datos de fichaje (hora y lugar en el momento en que ficha el inicio/fin de una tarea), utilizados para verificar su presencia en el lugar de trabajo y calcular su tiempo de trabajo. Esta localización solo se capta en el momento del fichaje. Usted no es seguido(a) fuera de esos instantes ni fuera de su horario de misión.
• Fotos de los alojamientos tomadas en el marco de los informes de limpieza y control de calidad, destinadas a documentar el estado de los inmuebles (no su persona).
• Informes de limpieza y control (duración, puntos validados, observaciones), transmitidos a los propietarios con fines de transparencia sobre la calidad del servicio, y utilizados internamente para el seguimiento de la calidad de las prestaciones.

Finalidades del tratamiento: estos datos se utilizan para la gestión de la nómina y del tiempo de trabajo, la transparencia frente a los propietarios, el seguimiento y la mejora continua de la calidad del servicio y, en su caso, para el seguimiento de la ejecución de sus misiones (pudiendo utilizarse en el marco de una conversación, un recordatorio de las consignas o un procedimiento disciplinario si se constatan incumplimientos repetidos de las consignas o de la calidad esperada).
Duración de conservación: la localización precisa asociada a cada fichaje se conserva 6 meses y después se elimina. Las horas de trabajo derivadas de ella (utilizadas para la nómina) se conservan 5 años, conforme a las obligaciones legales. Las fotos e informes de limpieza/control se conservan 24 meses. La localización precisa es accesible únicamente al personal habilitado del equipo de dirección; las horas de trabajo también se transmiten a la asesoría contable para la elaboración de la nómina; las fotos e informes son accesibles a la dirección y también al propietario del alojamiento correspondiente, en el marco del seguimiento de la calidad del servicio.
De conformidad con el RGPD, usted dispone de un derecho de acceso, rectificación y oposición sobre sus datos. Para cualquier solicitud, contacte con Franck Ferdoelle.`,
  checkbox_es:`He tomado conocimiento de esta información y del hecho de que los datos de seguimiento de actividad (fichaje, informes) pueden utilizarse en el marco del seguimiento de mi actividad profesional.`,
};

// Anti-esquive (défilement + délai minimum, cf SPEC §2.3) — valeurs fixes, décision
// Claire du 17/08/2026. Pas de recopie de phrase (retenu explicitement contre).
export const RGPD_SCROLL_DELAY_MS=27000; // ~27s avant activation, même si déjà scrollé en bas
export const CONSIGNE_CONTRAT_DELAI_MS=8000; // (v204) délai mini avant signature contrat location matériel — texte plus court que le RGPD, même principe (défilement + délai)
// Fenêtre de report (croix de fermeture) — passé ce délai depuis la première apparition,
// la croix disparaît. Le pointage reste toujours utilisable (décision Claire) : ce délai
// ne bloque QUE la fermeture/le report du document, jamais le travail.
export const RGPD_REPORT_WINDOW_MS=24*60*60*1000; // 24h

